"use strict";

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator/index.js");

var _toConsumableArray = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _asyncToGenerator = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidEIP1271Signature = exports.parseEmphemeralPayload = exports.getSignedIdentitySignatureType = exports.getEphemeralSignatureType = exports.EIP_1654_SIGNED_ENTITY_VALIDATOR = exports.ECDSA_EIP_1654_EPHEMERAL_VALIDATOR = exports.ECDSA_PERSONAL_EPHEMERAL_VALIDATOR = exports.ECDSA_SIGNED_ENTITY_VALIDATOR = exports.SIGNER_VALIDATOR = exports.Authenticator = exports.ERC1654_MAGIC_VALUE = exports.VALID_SIGNATURE = void 0;

var eth_connect_1 = __importStar(require("eth-connect"));

var SignatureValidator_1 = require("./contracts/SignatureValidator");

var types_1 = require("./types");

var utils_1 = require("./helper/utils");

var blocks_1 = __importDefault(require("./helper/blocks"));

var crypto_1 = require("./crypto");

exports.VALID_SIGNATURE = 'VALID_SIGNATURE'; // bytes4(keccak256("isValidSignature(bytes32,bytes)")

exports.ERC1654_MAGIC_VALUE = '1626ba7e';
var PERSONAL_SIGNATURE_LENGTH = 132;
var Authenticator;

(function (Authenticator) {
  /** Validate that the signature belongs to the Ethereum address */
  function validateSignature(_x, _x2, _x3) {
    return _validateSignature.apply(this, arguments);
  }

  function _validateSignature() {
    _validateSignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(expectedFinalAuthority, authChain, provider) {
      var dateToValidateExpirationInMillis,
          currentAuthority,
          _iterator2,
          _step2,
          authLink,
          validator,
          _yield$validator,
          nextAuthority,
          ok,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dateToValidateExpirationInMillis = _args.length > 3 && _args[3] !== undefined ? _args[3] : Date.now();
              currentAuthority = '';

              if (Authenticator.isValidAuthChain(authChain)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", {
                ok: false,
                message: 'ERROR: Malformed authChain'
              });

            case 4:
              _iterator2 = _createForOfIteratorHelper(authChain);
              _context.prev = 5;

              _iterator2.s();

            case 7:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 23;
                break;
              }

              authLink = _step2.value;
              validator = getValidatorByType(authLink.type);
              _context.prev = 10;
              _context.next = 13;
              return validator(currentAuthority, authLink, {
                provider: provider,
                dateToValidateExpirationInMillis: dateToValidateExpirationInMillis
              });

            case 13:
              _yield$validator = _context.sent;
              nextAuthority = _yield$validator.nextAuthority;
              currentAuthority = nextAuthority ? nextAuthority : '';
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](10);
              return _context.abrupt("return", {
                ok: false,
                message: "ERROR. Link type: ".concat(authLink.type, ". ").concat(_context.t0.message, ".")
              });

            case 21:
              _context.next = 7;
              break;

            case 23:
              _context.next = 28;
              break;

            case 25:
              _context.prev = 25;
              _context.t1 = _context["catch"](5);

              _iterator2.e(_context.t1);

            case 28:
              _context.prev = 28;

              _iterator2.f();

              return _context.finish(28);

            case 31:
              ok = currentAuthority === expectedFinalAuthority;
              return _context.abrupt("return", {
                ok: ok,
                message: ok ? undefined : "ERROR: Invalid final authority. Expected: ".concat(expectedFinalAuthority, ". Current ").concat(currentAuthority, ".")
              });

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 25, 28, 31], [10, 18]]);
    }));
    return _validateSignature.apply(this, arguments);
  }

  Authenticator.validateSignature = validateSignature;

  function isValidAuthChain(authChain) {
    var _iterator = _createForOfIteratorHelper(authChain.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            index = _step$value[0],
            authLink = _step$value[1];

        // SIGNER should be the first one
        if (index === 0 && authLink.type !== types_1.AuthLinkType.SIGNER) {
          return false;
        } // SIGNER should be unique


        if (authLink.type === types_1.AuthLinkType.SIGNER && index !== 0) {
          return false;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return true;
  }

  Authenticator.isValidAuthChain = isValidAuthChain; // https://github.com/ethereum/EIPs/blob/master/EIPS/eip-1271.md

  function createEIP1271MessageHash(msg) {
    return (0, eth_connect_1.hexToBytes)((0, eth_connect_1.sha3)((0, eth_connect_1.stringToUtf8Bytes)(msg)));
  }

  Authenticator.createEIP1271MessageHash = createEIP1271MessageHash;

  function createSimpleAuthChain(finalPayload, ownerAddress, signature) {
    return [{
      type: types_1.AuthLinkType.SIGNER,
      payload: ownerAddress,
      signature: ''
    }, {
      type: getSignedIdentitySignatureType(signature),
      payload: finalPayload,
      signature: signature
    }];
  }

  Authenticator.createSimpleAuthChain = createSimpleAuthChain;

  function createAuthChain(ownerIdentity, ephemeralIdentity, ephemeralMinutesDuration, entityId) {
    var expiration = (0, utils_1.moveMinutes)(ephemeralMinutesDuration);
    var ephemeralMessage = Authenticator.getEphemeralMessage(ephemeralIdentity.address, expiration);
    var firstSignature = Authenticator.createSignature(ownerIdentity, ephemeralMessage);
    var secondSignature = Authenticator.createSignature(ephemeralIdentity, entityId);
    var authChain = [{
      type: types_1.AuthLinkType.SIGNER,
      payload: ownerIdentity.address,
      signature: ''
    }, {
      type: types_1.AuthLinkType.ECDSA_PERSONAL_EPHEMERAL,
      payload: ephemeralMessage,
      signature: firstSignature
    }, {
      type: types_1.AuthLinkType.ECDSA_PERSONAL_SIGNED_ENTITY,
      payload: entityId,
      signature: secondSignature
    }];
    return authChain;
  }

  Authenticator.createAuthChain = createAuthChain;

  function initializeAuthChain(_x4, _x5, _x6, _x7) {
    return _initializeAuthChain.apply(this, arguments);
  }

  function _initializeAuthChain() {
    _initializeAuthChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ethAddress, ephemeralIdentity, ephemeralMinutesDuration, signer) {
      var expiration, ephemeralMessage, firstSignature, authChain;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              expiration = new Date();
              expiration.setMinutes(expiration.getMinutes() + ephemeralMinutesDuration);
              ephemeralMessage = Authenticator.getEphemeralMessage(ephemeralIdentity.address, expiration);
              _context2.next = 5;
              return signer(ephemeralMessage);

            case 5:
              firstSignature = _context2.sent;
              authChain = [{
                type: types_1.AuthLinkType.SIGNER,
                payload: ethAddress,
                signature: ''
              }, {
                type: getEphemeralSignatureType(firstSignature),
                payload: ephemeralMessage,
                signature: firstSignature
              }];
              return _context2.abrupt("return", {
                ephemeralIdentity: ephemeralIdentity,
                expiration: expiration,
                authChain: authChain
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _initializeAuthChain.apply(this, arguments);
  }

  Authenticator.initializeAuthChain = initializeAuthChain;

  function signPayload(authIdentity, entityId) {
    var secondSignature = Authenticator.createSignature(authIdentity.ephemeralIdentity, entityId);
    return [].concat(_toConsumableArray(authIdentity.authChain), [{
      type: types_1.AuthLinkType.ECDSA_PERSONAL_SIGNED_ENTITY,
      payload: entityId,
      signature: secondSignature
    }]);
  }

  Authenticator.signPayload = signPayload;
  Authenticator.createEthereumMessageHash = crypto_1.createEthereumMessageHash;

  function createSignature(identity, message) {
    return (0, crypto_1.ethSign)((0, eth_connect_1.hexToBytes)(identity.privateKey), message);
  }

  Authenticator.createSignature = createSignature;

  function ownerAddress(authChain) {
    if (authChain.length > 0) {
      if (authChain[0].type === types_1.AuthLinkType.SIGNER) {
        return authChain[0].payload;
      }
    }

    return 'Invalid-Owner-Address';
  }

  Authenticator.ownerAddress = ownerAddress;

  function getEphemeralMessage(ephemeralAddress, expiration) {
    return "Decentraland Login\nEphemeral address: ".concat(ephemeralAddress, "\nExpiration: ").concat(expiration.toISOString());
  }

  Authenticator.getEphemeralMessage = getEphemeralMessage;
})(Authenticator = exports.Authenticator || (exports.Authenticator = {}));

var SIGNER_VALIDATOR = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_, authLink) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", {
              nextAuthority: authLink.payload
            });

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function SIGNER_VALIDATOR(_x8, _x9) {
    return _ref.apply(this, arguments);
  };
}();

exports.SIGNER_VALIDATOR = SIGNER_VALIDATOR;

var ECDSA_SIGNED_ENTITY_VALIDATOR = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(authority, authLink) {
    var signerAddress, expectedSignedAddress, actualSignedAddress;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (authLink.signature) {
              _context4.next = 2;
              break;
            }

            throw new Error("Invalid AuthLink. 'signature' must be present for type 'ECDSA_SIGNED_ENTITY_VALIDATOR'");

          case 2:
            signerAddress = (0, crypto_1.recoverAddressFromEthSignature)(authLink.signature, authLink.payload);
            expectedSignedAddress = authority.toLocaleLowerCase();
            actualSignedAddress = signerAddress.toLocaleLowerCase();

            if (!(expectedSignedAddress === actualSignedAddress)) {
              _context4.next = 7;
              break;
            }

            return _context4.abrupt("return", {
              nextAuthority: authLink.payload
            });

          case 7:
            throw new Error("Invalid signer address. Expected: ".concat(expectedSignedAddress, ". Actual: ").concat(actualSignedAddress));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function ECDSA_SIGNED_ENTITY_VALIDATOR(_x10, _x11) {
    return _ref2.apply(this, arguments);
  };
}();

exports.ECDSA_SIGNED_ENTITY_VALIDATOR = ECDSA_SIGNED_ENTITY_VALIDATOR;

var ECDSA_PERSONAL_EPHEMERAL_VALIDATOR = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(authority, authLink, options) {
    var _parseEmphemeralPaylo, message, ephemeralAddress, expiration, dateToValidateExpirationInMillis, signerAddress, expectedSignedAddress, actualSignedAddress;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (authLink.signature) {
              _context5.next = 2;
              break;
            }

            throw new Error("Invalid AuthLink. 'signature' must be present for type 'ECDSA_PERSONAL_EPHEMERAL_VALIDATOR'");

          case 2:
            _parseEmphemeralPaylo = parseEmphemeralPayload(authLink.payload), message = _parseEmphemeralPaylo.message, ephemeralAddress = _parseEmphemeralPaylo.ephemeralAddress, expiration = _parseEmphemeralPaylo.expiration;
            dateToValidateExpirationInMillis = options.dateToValidateExpirationInMillis ? options.dateToValidateExpirationInMillis : Date.now();

            if (!(expiration > dateToValidateExpirationInMillis)) {
              _context5.next = 11;
              break;
            }

            signerAddress = (0, crypto_1.recoverAddressFromEthSignature)(authLink.signature, message);
            expectedSignedAddress = authority.toLocaleLowerCase();
            actualSignedAddress = signerAddress.toLocaleLowerCase();

            if (!(expectedSignedAddress === actualSignedAddress)) {
              _context5.next = 10;
              break;
            }

            return _context5.abrupt("return", {
              nextAuthority: ephemeralAddress
            });

          case 10:
            throw new Error("Invalid signer address. Expected: ".concat(expectedSignedAddress, ". Actual: ").concat(actualSignedAddress));

          case 11:
            throw new Error("Ephemeral key expired. Expiration: ".concat(expiration, ". Test: ").concat(dateToValidateExpirationInMillis));

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function ECDSA_PERSONAL_EPHEMERAL_VALIDATOR(_x12, _x13, _x14) {
    return _ref3.apply(this, arguments);
  };
}();

exports.ECDSA_PERSONAL_EPHEMERAL_VALIDATOR = ECDSA_PERSONAL_EPHEMERAL_VALIDATOR;

var ECDSA_EIP_1654_EPHEMERAL_VALIDATOR = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(authority, authLink, options) {
    var _parseEmphemeralPaylo2, message, ephemeralAddress, expiration, dateToValidateExpirationInMillis;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (authLink.signature) {
              _context6.next = 2;
              break;
            }

            throw new Error("Invalid AuthLink. 'signature' must be present for type 'ECDSA_EIP_1654_EPHEMERAL_VALIDATOR'");

          case 2:
            _parseEmphemeralPaylo2 = parseEmphemeralPayload(authLink.payload), message = _parseEmphemeralPaylo2.message, ephemeralAddress = _parseEmphemeralPaylo2.ephemeralAddress, expiration = _parseEmphemeralPaylo2.expiration;
            dateToValidateExpirationInMillis = (options === null || options === void 0 ? void 0 : options.dateToValidateExpirationInMillis) ? options === null || options === void 0 ? void 0 : options.dateToValidateExpirationInMillis : Date.now();

            if (!(expiration > dateToValidateExpirationInMillis)) {
              _context6.next = 9;
              break;
            }

            _context6.next = 7;
            return isValidEIP1654Message(options.provider, authority, message, authLink.signature, dateToValidateExpirationInMillis);

          case 7:
            if (!_context6.sent) {
              _context6.next = 9;
              break;
            }

            return _context6.abrupt("return", {
              nextAuthority: ephemeralAddress
            });

          case 9:
            throw new Error("Ephemeral key expired. Expiration: ".concat(expiration, ". Test: ").concat(dateToValidateExpirationInMillis));

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function ECDSA_EIP_1654_EPHEMERAL_VALIDATOR(_x15, _x16, _x17) {
    return _ref4.apply(this, arguments);
  };
}();

exports.ECDSA_EIP_1654_EPHEMERAL_VALIDATOR = ECDSA_EIP_1654_EPHEMERAL_VALIDATOR;

var EIP_1654_SIGNED_ENTITY_VALIDATOR = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(authority, authLink, options) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (authLink.signature) {
              _context7.next = 2;
              break;
            }

            throw new Error("Invalid AuthLink. 'signature' must be present for type 'EIP_1654_SIGNED_ENTITY_VALIDATOR'");

          case 2:
            _context7.next = 4;
            return isValidEIP1654Message(options.provider, authority, authLink.payload, authLink.signature, options.dateToValidateExpirationInMillis);

          case 4:
            if (!_context7.sent) {
              _context7.next = 6;
              break;
            }

            return _context7.abrupt("return", {
              nextAuthority: authLink.payload
            });

          case 6:
            throw new Error("Invalid validation");

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function EIP_1654_SIGNED_ENTITY_VALIDATOR(_x18, _x19, _x20) {
    return _ref5.apply(this, arguments);
  };
}();

exports.EIP_1654_SIGNED_ENTITY_VALIDATOR = EIP_1654_SIGNED_ENTITY_VALIDATOR;

var ERROR_VALIDATOR = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_, __) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", {
              error: 'Error Validator.'
            });

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function ERROR_VALIDATOR(_x21, _x22) {
    return _ref6.apply(this, arguments);
  };
}();

function getEphemeralSignatureType(signature) {
  if (signature.length === PERSONAL_SIGNATURE_LENGTH) {
    return types_1.AuthLinkType.ECDSA_PERSONAL_EPHEMERAL;
  } else {
    return types_1.AuthLinkType.ECDSA_EIP_1654_EPHEMERAL;
  }
}

exports.getEphemeralSignatureType = getEphemeralSignatureType;

function getSignedIdentitySignatureType(signature) {
  if (signature.length === PERSONAL_SIGNATURE_LENGTH) {
    return types_1.AuthLinkType.ECDSA_PERSONAL_SIGNED_ENTITY;
  } else {
    return types_1.AuthLinkType.ECDSA_EIP_1654_SIGNED_ENTITY;
  }
}

exports.getSignedIdentitySignatureType = getSignedIdentitySignatureType;

function parseEmphemeralPayload(payload) {
  // authLink payload structure: <human-readable message >\nEphemeral address: <ephemeral-eth - address >\nExpiration: <timestamp>
  // authLink payload example: Decentraland Login\nEphemeral address: 0x123456\nExpiration: 2020 - 01 - 20T22: 57: 11.334Z
  var message = payload.replace(/\r/g, '');
  var payloadParts = message.split('\n');
  var ephemeralAddress = payloadParts[1].substring('Ephemeral address: '.length);
  var expirationString = payloadParts[2].substring('Expiration: '.length);
  var expiration = Date.parse(expirationString);
  return {
    message: message,
    ephemeralAddress: ephemeralAddress,
    expiration: expiration
  };
}

exports.parseEmphemeralPayload = parseEmphemeralPayload;

function isValidEIP1271Signature(_x23, _x24, _x25, _x26) {
  return _isValidEIP1271Signature.apply(this, arguments);
}

function _isValidEIP1271Signature() {
  _isValidEIP1271Signature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(signatureValidator, message, signature, block) {
    var hashedMessage, _signature, result, hashedMessageWithPrefix;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            hashedMessage = Authenticator.createEIP1271MessageHash(message);
            _signature = (0, eth_connect_1.hexToBytes)(signature);
            _context9.prev = 2;
            _context9.t0 = (0, eth_connect_1.bytesToHex);
            _context9.next = 6;
            return signatureValidator.isValidSignature(hashedMessage, _signature, block);

          case 6:
            _context9.t1 = _context9.sent;
            result = (0, _context9.t0)(_context9.t1);
            _context9.next = 12;
            break;

          case 10:
            _context9.prev = 10;
            _context9.t2 = _context9["catch"](2);

          case 12:
            if (!(result === exports.ERC1654_MAGIC_VALUE)) {
              _context9.next = 14;
              break;
            }

            return _context9.abrupt("return", true);

          case 14:
            hashedMessageWithPrefix = (0, crypto_1.createEthereumMessageHash)(message);
            _context9.prev = 15;
            _context9.t3 = (0, eth_connect_1.bytesToHex);
            _context9.next = 19;
            return signatureValidator.isValidSignature(hashedMessageWithPrefix, _signature, block);

          case 19:
            _context9.t4 = _context9.sent;
            result = (0, _context9.t3)(_context9.t4);
            _context9.next = 25;
            break;

          case 23:
            _context9.prev = 23;
            _context9.t5 = _context9["catch"](15);

          case 25:
            return _context9.abrupt("return", result === exports.ERC1654_MAGIC_VALUE);

          case 26:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[2, 10], [15, 23]]);
  }));
  return _isValidEIP1271Signature.apply(this, arguments);
}

exports.isValidEIP1271Signature = isValidEIP1271Signature;

function isValidEIP1654Message(_x27, _x28, _x29, _x30, _x31) {
  return _isValidEIP1654Message.apply(this, arguments);
}

function _isValidEIP1654Message() {
  _isValidEIP1654Message = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(provider, contractAddress, message, signature, dateToValidateExpirationInMillis) {
    var requestManager, signatureValidator, result, dater, _yield$dater$getDate, block;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (provider) {
              _context10.next = 2;
              break;
            }

            throw new Error('Missing provider');

          case 2:
            requestManager = new eth_connect_1.default(provider);
            _context10.next = 5;
            return (0, SignatureValidator_1.SignatureValidator)(requestManager, contractAddress);

          case 5:
            signatureValidator = _context10.sent;
            _context10.next = 8;
            return isValidEIP1271Signature(signatureValidator, message, signature);

          case 8:
            result = _context10.sent;

            if (!result) {
              _context10.next = 11;
              break;
            }

            return _context10.abrupt("return", true);

          case 11:
            // check based on the dateToValidateExpirationInMillis
            dater = new blocks_1.default(requestManager);
            _context10.prev = 12;
            _context10.next = 15;
            return dater.getDate(dateToValidateExpirationInMillis, false);

          case 15:
            _yield$dater$getDate = _context10.sent;
            block = _yield$dater$getDate.block;
            _context10.next = 19;
            return isValidEIP1271Signature(signatureValidator, message, signature, block);

          case 19:
            result = _context10.sent;

            if (!result) {
              _context10.next = 22;
              break;
            }

            return _context10.abrupt("return", true);

          case 22:
            _context10.next = 27;
            break;

          case 24:
            _context10.prev = 24;
            _context10.t0 = _context10["catch"](12);
            throw new Error("Invalid validation. Error: ".concat(_context10.t0.message));

          case 27:
            throw new Error("Invalid validation. Expected: ".concat(exports.ERC1654_MAGIC_VALUE, ". Actual: ").concat(result));

          case 28:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[12, 24]]);
  }));
  return _isValidEIP1654Message.apply(this, arguments);
}

function getValidatorByType(type) {
  switch (type) {
    case types_1.AuthLinkType.SIGNER:
      return exports.SIGNER_VALIDATOR;

    case types_1.AuthLinkType.ECDSA_PERSONAL_EPHEMERAL:
      return exports.ECDSA_PERSONAL_EPHEMERAL_VALIDATOR;

    case types_1.AuthLinkType.ECDSA_PERSONAL_SIGNED_ENTITY:
      return exports.ECDSA_SIGNED_ENTITY_VALIDATOR;

    case types_1.AuthLinkType.ECDSA_EIP_1654_EPHEMERAL:
      return exports.ECDSA_EIP_1654_EPHEMERAL_VALIDATOR;

    case types_1.AuthLinkType.ECDSA_EIP_1654_SIGNED_ENTITY:
      return exports.EIP_1654_SIGNED_ENTITY_VALIDATOR;

    default:
      return ERROR_VALIDATOR;
  }
}